import isAuthenticated from './is-authenticated';

export default {
  isAuthenticated,
};
